import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MdIconModule, MdSelectModule, MdButtonModule } from '@angular/material';

import { TdPagingBarComponent } from './paging-bar.component';

export { TdPagingBarComponent, IPageChangeEvent } from './paging-bar.component';
export class QuiverPagingModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        FormsModule,
        CommonModule,
        MdIconModule,
        MdSelectModule,
        MdButtonModule
    ],
    declarations: [
        TdPagingBarComponent
    ],
    exports: [
        TdPagingBarComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverPagingModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverPagingModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverPagingModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
